<template>
	<div>
		<slot :descargarFactura="descargarFactura" :cancelarFactura="cancelarFactura" :esFacturable="esFacturable" :esConciliacion="esConciliacion" :movimientos="movimientos" :metodoPago="metodoPago" :personaid="personaid" :facturar="facturar" :saldos="saldos" :inline="inline" :st="st">
		</slot>
	</div>
</template>
<script>
import Axios from 'axios';
export default {
	props: [
	'id'
	],
	data() {return {
		movimientos: [],
		inline: [],
		saldos: {
			descuentosAplicados: 0,
			pagosRealizados: 0,
			becasAplicadas: 0,
			saldoPendiente: 0,
			saldoTotal: 0
		},
		metodoPago: {},
		st: {},
		esConciliacion: false,
		esFacturable: false,
		personaid: null
	}},
	mounted() {
		const vm = this;
		vm.getEstadoDeCuenta();

		$('.checkChange').change(function() {
			console.log('algo cambió');
		});
	},
	methods: {
		getEstadoDeCuenta() {
			Axios.get('/estado-de-cuenta/'+this.id+'/movimientos').then(res => {
				this.movimientos = res.data.data;
				this.st = res.data.st;
				this.saldos.saldoPendiente = res.data.saldoPendiente;
				this.saldos.pagosRealizados = res.data.pagosRealizados;
				this.saldos.descuentosAplicados = res.data.descuentosAplicados;
				this.saldos.becasAplicadas = res.data.becasAplicadas;
				this.saldos.saldoTotal = res.data.saldoTotal;
			}).catch(e => {
				console.log(e);
			}).finally(() => {
				this.puedeFacturar();
			})
		},
		puedeFacturar() {
			let conteo = 0;
			this.movimientos.forEach(ciclo => {
				ciclo.movimientos.forEach(movimiento => {				

					if (movimiento.facturacion_disponible) {
						conteo++;
					}
				});
			});
			if(conteo > 0) {
				this.esFacturable = true;
			}
		},
		facturar(persona_id) {
			let conteo = 0;
			this.inline = [];
			this.movimientos.forEach(ciclo => {
				ciclo.movimientos.forEach(movimiento => {
					if(movimiento.select) {
						if ((typeof(movimiento.nombre_metodo_pago.id) !== 'undefined') && (movimiento.fuente_movimiento_id == 11 || movimiento.fuente_movimiento_id == 13)) { 
							this.metodoPago = movimiento.nombre_metodo_pago; 
							this.esConciliacion = true; 
						}
						conteo++;
						this.inline.push(movimiento);
					}
				});
			});
			if(conteo > 0) {
				this.personaid = persona_id
				$('#facturarPagos').modal('show');
			} else {
				toastr["warning"]('Primero debe seleccionar al menos un movimiento');
			}
		},
		descargarFactura(movimiento) {
			Axios.get(`/estado-de-cuenta/facturacion/${movimiento.persona_id}/persona/${movimiento.id}/movimiento/factura`, { 
				responseType: 'arraybuffer',
				headers: { 'Accept': 'application/pdf' }
			}).then(response => {

				const newBlob = new Blob([response.data], {type: 'application/pdf'});

				// IE doesn't allow using a blob object directly as link href
				// instead it is necessary to use msSaveOrOpenBlob

				if (window.navigator && window.navigator.msSaveOrOpenBlob) {

					window.navigator.msSaveOrOpenBlob(newBlob)
					return;
				}

				// For other browsers:
				// Create a link pointing to the ObjectURL containing the blob.
				const data = window.URL.createObjectURL(newBlob);
				const link = document.createElement('a');
				link.href = data;
				link.download = `${movimiento.cfdi_facturado.uuid}.pdf`;
				link.click();
				setTimeout(function () {

	    			// For Firefox it is necessary to delay revoking the ObjectURL
	    			window.URL.revokeObjectURL(data);

	    		}, 100);

			}).catch(e => {
				if (e.response.data && e.response.data.message) { toastr["error"](e.response.data.message, 'Error'); } else {
					toastr["error"](e, 'Error al descargar la factura'); 
				}
			});

		},
		cancelarFactura(movimiento) {

			if (!movimiento.cfdi_facturado || !movimiento.datos_emisor) {

				toastr["error"]('Información inválida para la cancelación, por favor verifique los datos: RFC emisor y uuid'); 
			}

			Axios.post(`/estado-de-cuenta/facturacion/${movimiento.cfdi_facturado.uuid}/cfdi/${movimiento.datos_emisor.Rfc}/emisor/cancelar-factura`)
			.then(response => {	toastr["success"]('Factura cancelada correctamente'); })
			.catch(e => { 
				
				if (e.response.data && e.response.data.message) { 

					toastr["warning"](`${e.response.data.message}`, 'Error'); 

				} else { 
					toastr["error"](e, 'Ocurrió un problema inesperado al tratar de cancelar el pago'); 
				} 
			});

		}
	}
}
</script>
